import { create } from 'zustand'
import { devtools } from 'zustand/middleware'

import { Attachment } from '../@types/RequestQuotation'

type Quotation = {
  agentObservations?: string
  conditionDetails?: string
  otherRiskFactors?: string
  commercialStudy?: string
  relatedEntityNIF?: string
  attachments?: Attachments[]
}

type Attachments = {
  id: number
} & Attachment

type Store = {
  quotation: Quotation | null
  setQuotation: (value: Quotation) => void
  updateQuotation: (value: Quotation) => void
  deleteAttachments: (id: number) => void
}

export const useQuotationStore = create<Store>()(
  devtools(
    (set) => ({
      quotation: { attachments: [] },
      setQuotation: (quotation) => set({ quotation }),
      updateQuotation: (updatedValues) =>
        set((state) => ({
          quotation: {
            ...state.quotation,
            ...updatedValues,
          },
        })),
      deleteAttachments: (id) =>
        set((state) => {
          const newData = state.quotation?.attachments?.filter(
            (file) => file.id !== id,
          )

          return { quotation: { ...state.quotation, attachments: newData } }
        }),
    }),
    { name: 'QuotationStore' },
  ),
)
